import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';

interface File {
  originalSourceUrl: string;
  previewUrl: string;
  fileName: string;
  file_type?: string;
}

interface PrintQResponse {
  status?: number;
  message?: string;
  // The response is an object in case data is present, otherwise it's an empty array
  data: Record<string, File> | [];
  allObjects?: {
    [key: string]: string | number | unknown;
  }[];
}

class PrintQService extends Api {
  async getUploadedFiles(docRef: string): Promise<PrintQResponse | null> {
    try {
      const params = new URLSearchParams();
      params.append('docRef', docRef);
      const {
        data: {
          data,
          allObjects,
        },
      } = await this.httpClient.get<PrintQResponse>(`getUploadedFiles?${params}`);
      return { data, allObjects: allObjects || [] };
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        fingerprint: ['printq-service-get-uploaded-files'],
      });
    }
    return null;
  }
}

export default PrintQService;
